var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5002 0.571695C18.6866 0.570618 18.8714 0.606354 19.044 0.676853C19.2166 0.747354 19.3736 0.85123 19.506 0.982529C19.7699 1.24796 19.918 1.60702 19.918 1.98128C19.918 2.35554 19.7699 2.7146 19.506 2.98003L11.006 11.48C10.8748 11.6139 10.7183 11.7204 10.5457 11.7933C10.373 11.8663 10.1876 11.9043 10.0002 11.905C9.81274 11.9043 9.62733 11.8663 9.45467 11.7933C9.28201 11.7204 9.12555 11.6139 8.99435 11.48L0.494346 2.98003C0.230491 2.7146 0.0823871 2.35554 0.0823871 1.98128C0.082387 1.60702 0.230491 1.24796 0.494346 0.98253C0.626042 0.849748 0.782725 0.744357 0.955359 0.672435C1.12799 0.600512 1.31316 0.563483 1.50018 0.563483C1.68719 0.563483 1.87236 0.600512 2.045 0.672434C2.21763 0.744357 2.37431 0.849748 2.50601 0.98253L10.0002 8.42003L17.4377 0.982529C17.5767 0.844245 17.7429 0.736329 17.9258 0.665611C18.1087 0.594894 18.3043 0.562913 18.5002 0.571695Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.245132c7c661291c9a4e8b2c4df08348.svg";
export { ForwardRef as ReactComponent };